__turbopack_context__.v({
  "rating": "Rating-module-scss-module__ZPTaCa__rating",
});
